import React from "react";
import "./ComparisonTable.css";

const ComparisonTable = () => {
  return (
    <section className="comparison-section">
      <h2 className="section-title">📊 Jämför våra alternativ</h2>
      <p className="section-subtitle">Se vilket paket som passar dig bäst</p>

      <div className="comparison-table">
        <div className="table-header">
          <div className="feature-title">Funktioner</div>
          <div className="plan">E-bok<br /><span className="price">499 €</span><br /><a href="https://school.emacademy.se/p/e-bok-dropshipping" className="buy-button">Ladda ner</a></div>
          <div className="plan popular">Kurs<br /><span className="price">2 500 €</span><br /><a href="https://school.emacademy.se/p/dropshippingkurs" className="buy-button">Starta nu</a></div>
          <div className="plan">Mentorskap<br /><span className="price">4 500 €</span><br /><a href="https://school.emacademy.se/p/mentorskap" className="buy-button">Ansök nu</a></div>
        </div>

        {[
          ["Tillgång direkt efter köp", true, true, true],
          ["Livstidsaccess", true, true, true],
          ["Video-material", false, true, true],
          ["Personlig feedback", false, false, true],
          ["Tillgång till Discord-community", "1 mån", "6 mån", "12 mån"],
          ["1–1 coaching", false, false, true],
          ["Bonusresurser & mallar", false, true, true],
          ["Direkt DM-support", false, false, true],
        ].map(([feature, ebook, course, mentorship], index) => (
          <div className="table-row" key={index}>
            <div className="feature-title">{feature}</div>
            <div className="plan">{typeof ebook === 'string' ? ebook : ebook === true ? "✅" : ""}</div>
            <div className="plan">{typeof course === 'string' ? course : course === true ? "✅" : ""}</div>
            <div className="plan">{typeof mentorship === 'string' ? mentorship : mentorship === true ? "✅" : ""}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComparisonTable;